import * as React from "react";
const SvgMinimize01 = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M20.269 2.269a1.034 1.034 0 1 1 1.463 1.462l-5.234 5.234H20a1.035 1.035 0 0 1 0 2.07h-6A1.035 1.035 0 0 1 12.965 10V4a1.035 1.035 0 0 1 2.07 0v3.502zM11.035 20a1.035 1.035 0 0 1-2.07 0v-3.502L3.73 21.731A1.034 1.034 0 1 1 2.27 20.27l5.233-5.234H4a1.035 1.035 0 0 1 0-2.07h6c.572 0 1.035.463 1.035 1.035z"
}));
export default SvgMinimize01;
//# sourceMappingURL=Minimize01.js.map